import { Box, Chip, Stack, Tab, TabList } from "@compass/core";
import { PartnerViewResource, Permission, PermissionAction } from "generated/openApi";
import "moment-timezone";
import { isAuthorized } from "services";
import { PartnerTab } from "./PartnerPage";

export const PartnerTabs = (props: {
  viewResource: PartnerViewResource;
  setCurrentTab: (value: PartnerTab) => void;
}) => {
  const tabs: PartnerTab[] = initTabs();

  function initTabs(): PartnerTab[] {
    let tabs: PartnerTab[] = [];
    tabs.push("Partner");
    if (isAuthorized(Permission.MatchUtility, PermissionAction.View)) tabs.push("Indirect Costs");
    if (isAuthorized(Permission.MatchUtility, PermissionAction.View)) tabs.push("Sub-Partners");
    return tabs;
  }

  const tabTotals: [PartnerTab, number | undefined][] = [
    ["Indirect Costs", props.viewResource.indirectCostsTotal],
    ["Sub-Partners", props.viewResource.subPartnersTotal],
  ];

  return (
    <TabList
      onChange={(e, value) => props.setCurrentTab(value)}
      variant="scrollable"
      scrollButtons
      allowScrollButtonsMobile
    >
      {tabs.map((tab) => {
        const total: number | undefined = tabTotals.find((x) => x[0] === tab)?.[1];

        return (
          <Tab
            key={tab}
            label={
              <Stack direction="row" spacing="sm" alignItems="center">
                <Box>{tab}</Box>
                {total !== undefined && total !== null && <Chip label={total} size="small" />}
              </Stack>
            }
            value={tab}
          />
        );
      })}
    </TabList>
  );
};
